import BudgetBillingInfo from "@/interfaces/OilEnergy/BudgetBillingInfo";
import Report from "@/interfaces/Reports/Report";
import BudgetBillingTransaction from "@/interfaces/OilEnergy/BudgetBillingTransaction";
import EnergyAssistance from "@/interfaces/OilEnergy/EnergyAssistance";
import LeaseAgreement from "@/interfaces/OilEnergy/LeaseAgreement";
import SalesContract from "@/interfaces/OilEnergy/SalesContract";
import Tank from "@/interfaces/OilEnergy/Tank";
import TankDelivery from "@/interfaces/OilEnergy/TankDelivery";
import TankListItem from "@/interfaces/OilEnergy/TankListItem";
import { portalHttpClient, suppressErrorAlert } from "@/services/httpClient";

const END_POINT = "api/customerPortal/v1/oilEnergy";

export async function getTanks(): Promise<Tank[]> {
  let tanks = [] as Tank[];

  await portalHttpClient
    .get(`${END_POINT}/tanks`)
    .then((response) => (tanks = response.data));

  return tanks;
}

export async function getLeaseAgreements(): Promise<LeaseAgreement[]> {
  let agreements = [] as LeaseAgreement[];

  await portalHttpClient
    .get(`${END_POINT}/leaseAgreements`)
    .then((response) => (agreements = response.data));

  return agreements;
}

export async function getEnergyAssistance(): Promise<EnergyAssistance[]> {
  let commitments = [] as EnergyAssistance[];

  await portalHttpClient
    .get(`${END_POINT}/energyAssistance`)
    .then((response) => (commitments = response.data));

  return commitments;
}

export async function getSalesContracts(): Promise<SalesContract[]> {
  let contracts = [] as SalesContract[];

  await portalHttpClient
    .get(`${END_POINT}/salesContracts`)
    .then((response) => (contracts = response.data));

  return contracts;
}

export async function getDeliveries(
  tankId: string,
  period: string,
  beginDate: string,
  endDate: string
): Promise<TankDelivery[]> {
  let deliveries = [] as TankDelivery[];

  await portalHttpClient
    .get(`${END_POINT}/deliveries`, {
      params: {
        tankId: tankId,
        period: period,
        beginDate: beginDate,
        endDate: endDate,
      },
    })
    .then((response) => (deliveries = response.data));

  return deliveries;
}

export async function getBudgetBillingInfo(): Promise<BudgetBillingInfo> {
  let info = {} as BudgetBillingInfo;

  await portalHttpClient
    .get(`${END_POINT}/budgetBilling`)
    .then((response) => (info = response.data));

  return info;
}

/**
 * The whole activity set. The page filters it by type in the browser, because the types it offers are the ones
 * the account actually has rather than every code Merchant defines.
 */
export async function getBudgetBillingTransactions(): Promise<
  BudgetBillingTransaction[]
> {
  let transactions = [] as BudgetBillingTransaction[];

  await portalHttpClient
    .get(`${END_POINT}/budgetBilling/transactions`)
    .then((response) => (transactions = response.data));

  return transactions;
}

export async function getTankList(): Promise<TankListItem[]> {
  let tanks = [] as TankListItem[];

  await portalHttpClient
    .get(`${END_POINT}/tanks/list`)
    .then((response) => (tanks = response.data));

  return tanks;
}

/**
 * Resolved per customer through the entity scoped API, because in an entity install the customer record only
 * exists in that entity's own database and the account list cannot reach it.
 */
//The store settles this to false when it cannot be read and retries once, so a failure is already
//accounted for. Without suppression the retry raises the generic banner twice, over a page that works.
export async function getIsOilEnergyCustomer(): Promise<boolean> {
  let isOilEnergyCustomer = false;

  await portalHttpClient
    .get(`${END_POINT}/isOilEnergyCustomer`, suppressErrorAlert)
    .then((response) => (isOilEnergyCustomer = response.data));

  return isOilEnergyCustomer;
}

export async function getSalesContractStatement(
  contractId: string
): Promise<Report> {
  let report = {} as Report;

  await portalHttpClient
    .get(
      `${END_POINT}/salesContracts/${encodeURIComponent(
        contractId
      )}/statement`
    )
    .then((response) => (report = response.data));

  return report;
}
